import React from "react";

import { Chip, ChipProps } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import clsx from "clsx";

import makeStyles from "hooks/makeStyles";

const useStyles = makeStyles(theme => ({
	root: {
		height: theme.spacing(4),
		color: theme.palette.primary.contrastText,
		backgroundColor: theme.palette.primary.main,
		// marginLeft: theme.spacing(2),
		// marginRight: theme.spacing(2),
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		textTransform: "uppercase",
		"&:hover, &:focus": {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText
		},
		"&:active": {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText
		}
	},
	deleteIcon: {
		height: theme.spacing(3),
		color: "#fff"
	}
}));

interface Props extends ChipProps {}

const SelectorChip = ({ className, onClick, onDelete, ...otherProps }: Props) => {
	const classes = useStyles();

	return (
		<Chip
			className={clsx(classes.root, className)}
			deleteIcon={<ExpandMore className={classes.deleteIcon} />}
			clickable
			onClick={onClick}
			onDelete={onDelete || onClick}
			{...otherProps}
		/>
	);
};

export default SelectorChip;
